/* eslint-disable */

export interface IV1GetBillingStatusResponseSchema {
  /** Статус оплаты заявки на оказание услуги **/
  status: EStatus;
}
export enum EStatus {
  /** Оплата счета отменена **/
  'Canceled' = 'canceled',
  /** Ошибка оплаты счета **/
  'Error' = 'error',
  /** Счет оплачен **/
  'Paid' = 'paid',
  /** Счет не оплачен **/
  'Unpaid' = 'unpaid',
}
